// Engine registry — maps rulesetId → engine module.
import * as zimbabwe from "./engine";
import * as oware from "./engines/oware";
import * as mbothe from "./engines/mbothe";
import * as nchombwa from "./engines/nchombwa";
import * as chisolo from "./engines/chisolo";
import * as ayoayo from "./engines/ayoayo";

// Keys are BOTH the ruleset.id (used by rulesets.js / routes) AND the engineId
// (used by older code paths). Multiple aliases point to the same engine module.
const REGISTRY = {
  // Zimbabwe
  "zimbabwe-standard": zimbabwe,
  // Ghana — Oware Abapa
  "gh-oware-abapa": oware,
  "ghana-oware": oware,
  // Kenya — Mbothe
  "ke-mbothe-standard": mbothe,
  "kenya-mbothe": mbothe,
  // Malawi / Zambia — Nchombwa / Nsolo
  "mw-nchombwa-standard": nchombwa,
  "zambia-malawi-nsolo": nchombwa,
  // Zambia — Chisolo (Natatu)
  "zm-chisolo-natatu": chisolo,
  "zambia-chisolo": chisolo,
  // Nigeria — Ayoayo (Ayò Ọlọ́pọ́n, relay)
  "ng-ayoayo-relay": ayoayo,
  "nigeria-ayo": ayoayo,
};

export function getEngine(rulesetId) {
  const e = REGISTRY[rulesetId];
  if (!e) {
    // eslint-disable-next-line no-console
    console.warn(`No engine registered for ruleset '${rulesetId}', falling back to zimbabwe-standard.`);
    return zimbabwe;
  }
  return e;
}

export function hasEngine(rulesetId) {
  return Boolean(REGISTRY[rulesetId]);
}

export function listRegisteredEngines() {
  return Object.keys(REGISTRY);
}
